import * as $ from "jquery";

export class PasswordRules
{
	public passwordRule()
	{
		return Object.assign({},
			this.userPasswordRule(),
			this.userPasswordConfirmRule()
		)
	}

	private userPasswordRule()
	{
		$.validator.addMethod(
			"userPassword",
			function (value) {

				if(value.length > 7) {
					return /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*\W)/.test(value);
				}
			},
			$.validator.format('Hasło musi zawierać przynajmniej (6 znaków, jedną małą i jedną wielką literę, jedną cyfrę i jeden znak specjalny)')
		);
	}

	private userPasswordConfirmRule()
	{
		$.validator.addMethod(
			"userPasswordConfirm",
			function (value) {

				let object = $('#userPassword');

				if(!object.length) {
					object = $('#repassword');
				}
				let userPassword = object.val();

				if(value === userPassword) {
					return true;
				}
			},
			$.validator.format('Hasła muszą być identyczne')
		);
	}
}















import * as $ from "jquery";

export class PasswordRules
{
	public passwordRule()
	{
		return Object.assign({},
			this.userPasswordRule(),
			this.userPasswordConfirmRule()
		)
	}

	private userPasswordRule()
	{
		$.validator.addMethod(
			"userPassword",
			function (value) {

				if(value.length > 7) {
					return /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*\W)/.test(value);
				}
			},
			$.validator.format('Hasło musi zawierać przynajmniej (6 znaków, jedną małą i jedną wielką literę, jedną cyfrę i jeden znak specjalny)')
		);
	}

	private userPasswordConfirmRule()
	{
		$.validator.addMethod(
			"userPasswordConfirm",
			function (value) {

				let object = $('#userPassword');

				if(!object.length) {
					object = $('#repassword');
				}
				let userPassword = object.val();

				if(value === userPassword) {
					return true;
				}
			},
			$.validator.format('Hasła muszą być identyczne')
		);
	}
}















